import React from "react";
import { UltimaAtualizacaoText } from "./ultima-atualizacao.styles";

interface UltimaAtualizacaoProps {
  data?: string | null;
}

export function UltimaAtualizacao({ data }: UltimaAtualizacaoProps) {
  if (!data) {
    return <UltimaAtualizacaoText>Sem registro de atualização</UltimaAtualizacaoText>;
  }

  const formatted = new Date(data).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return <UltimaAtualizacaoText>Última atualização: {formatted}</UltimaAtualizacaoText>;
}
